export default __webpack_public_path__ + "static/media/0117_IMG7933.74cf3150.jpg";